<template>
  <v-container fluid grid-list-md>
    <v-data-iterator
      :items="process"
      :rows-per-page-items="rowsPerPageItems"
      :pagination.sync="pagination"
      :no-data-text="'Please add process'"
      content-tag="v-layout"
      row
      wrap
    >
      <template v-slot:item="props">
        <process
          :edit="edit"
          :process="props.item"
          :processCount="process.length"
          :planned_processes="trial.planned_processes"
        />
      </template>
      <template v-if="permissions.EDIT" v-slot:actions-append>
        <template v-if="edit">
          <v-tooltip v-if="process.length < trial.planned_processes" bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                fab
                small
                color="success"
                :disabled="isResetProcess || isSendingProcess"
                v-on="on"
                @click="addNewProcess"
              >
                <v-icon>add</v-icon>
              </v-btn>
            </template>
            <span>Добавить процесс производства продукта</span>
          </v-tooltip>
          <v-btn
            @click="reset"
            :loading="isResetProcess"
            :disabled="isResetProcess || isSendingProcess"
            flat
            color="warning"
          >
            Reset
          </v-btn>
          <v-btn
            :loading="isSendingProcess"
            :disabled="isSendingProcess || isResetProcess"
            @click="saveProcesses"
            color="success"
          >
            Save
          </v-btn>
        </template>
      </template>
    </v-data-iterator>
    <template v-if="permissions.EDIT">
      <new-process-popup
        v-if="edit"
        @createNewProcess="createNewProcess"
        :dialog.sync="newProcessPopupStatus"
      />
      <edit-process-popup
        v-if="edit"
        :dialog.sync="editProcessPopupStatus"
        :process="selectedProcess"
        :filteredProcess="planned_processes_list_id"
        @update="updateProcess"
      />
      <edit-process-stage-popup
        v-if="edit"
        :dialog.sync="editProcessStagePopupStatus"
        :stage="selectedProcessStage"
        :steps="selectedProcessStageSteps"
        @update="updateSteps"
      />
      <edit-process-stage-step-popup
        v-if="edit"
        @update="updateStep"
        :dialog.sync="editProcessStageStepPopupStatus"
        :step="selectedProcessStageStep"
      />
    </template>
  </v-container>
</template>
<script>
import Process
  from '@/orm/models/Process';
import Recipes
  from '@/orm/models/Recipes';
import Trial
  from '@/orm/models/Trial';
import RecipeModule
  from '@/orm/models/RecipeModule';

export default {
  name: 'processes',
  props: {
    trial_id: [Number, String],
    edit: {
      type: Boolean,
      default: () => false,
    },
    permissions: Object,
  },
  provide() {
    return {
      editProcess: this.editProcess,
      editStage: this.editStage,
      editStep: this.editStep,
      addNewProcess: this.addNewProcess,
    };
  },
  data() {
    return {
      rowsPerPageItems: [3, {
        'text': '$vuetify.dataIterator.rowsPerPageAll',
        'value': -1,
      }],
      pagination: {
        rowsPerPage: -1,
      },
      newProcessPopupStatus: false,
      editProcessPopupStatus: false,
      selectedProcess: new Process(),
      isSendingProcess: false,
      isResetProcess: false,
      editProcessStagePopupStatus: false,
      selectedProcessStage: null,
      selectedProcessStageSteps: [],
      editProcessStageStepPopupStatus: false,
      selectedProcessStageStep: {},
      copyTrial: null,
    };
  },
  watch: {
    async currentGroup() {
      await this.reset();
    },
  },
  computed: {
    trial() {
      return Trial.find(+this.trial_id);
    },
    process() {
      return Process
        .all()
        .map(process => {
          process.stages.forEach(stage => {
            stage.steps.forEach(step => {
              if (step['recipes']) return;
              const recipes = this.recipes.filter(recipe => recipe.process_id === process.id);
              step['recipes'] = recipes.map(recipe => ({
                id: recipe.id,
                name: recipe.name,
                unique_id: recipe.unique_id,
                selectedParameters: step.selectedParameters,
              }));
            });
          });
          return process;
        });
    },
    recipes() {
      return Recipes.all();
    },
    editLocal: {
      get() {
        return this.edit;
      },
      set(val) {
        this.$emit('update:edit', val);
      },
    },
    planned_processes_list_id() {
      return this.trial.planned_processes_list;
    },
  },
  methods: {
    async createNewProcess(name, processData=null) {
      if (this.copyTrial) {
        this.copyTrial.name = name;
      }
      await Process.insert({
        data: this.copyTrial || processData || { name },
      });
      this.copyTrial = null;
    },
    editProcess(id) {
      this.editProcessPopupStatus = true;
      this.selectedProcess = Process.find(id);
    },
    async updateProcess({ process }) {
      await Process.insertOrUpdate({ data: process });
      this.resetSelected();
    },
    addNewProcess(newItem) {
      this.newProcessPopupStatus = true;
      if (newItem && !(newItem instanceof MouseEvent)) {
        this.copyTrial = newItem;
      }
    },
    goToEditProcesses() {
      this.editLocal = true;
    },
    async reset() {
      try {
        this.isResetProcess = true;
        const { params } = this.$route;
        const { processes } = await RecipeModule.$get({ params });
        await Process.create({
          data: processes,
        });
      } finally {
        this.isResetProcess = false;
        this.editLocal = false;
      }
    },
    async saveProcesses() {
      try {
        const processesLocal = this.process;
        this.isSendingProcess = true;
        const { params } = this.$route;
        const { processes } = await RecipeModule.$create({
          params,
          data: {
            processes: processesLocal,
          },
        });
        await Process.create({
          data: processes,
        });
      } finally {
        this.isSendingProcess = false;
        this.editLocal = false;
      }
    },
    async updateSteps(steps) {
      const self = this;
      await Process.update({
        where: this.selectedProcess.id,
        data(process) {
          const currentStage = process.stages.find(st => st.id === self.selectedProcessStage.id);
          currentStage.steps = JSON.parse(JSON.stringify(steps));
        },
      });
      this.resetSelected();
    },
    editStage(processId, stageId) {
      this.selectedProcess = Process.find(processId);
      this.selectedProcessStage = this.selectedProcess.stages.find(stg => stg.id === stageId);
      this.selectedProcessStageSteps = this.selectedProcessStage.steps;
      this.editProcessStagePopupStatus = true;
    },
    editStep(processId, stageId, stepId) {
      this.selectedProcess = Process.find(processId);
      this.selectedProcessStage = this.selectedProcess.stages.find(stg => stg.id === stageId);
      this.selectedProcessStageStep = this.selectedProcessStage.steps.find(stp => stp.id === stepId);
      this.editProcessStageStepPopupStatus = true;
    },
    async updateStep(data) {
      const self = this;
      await Process.update({
        where: this.selectedProcess.id,
        data(process) {
          const currentStage = process.stages.find(st => st.id === self.selectedProcessStage.id);
          currentStage.steps = currentStage.steps.map(s => {
            if (s.id !== self.selectedProcessStageStep.id) return s;
            s = JSON.parse(JSON.stringify(data));
            return s;
          });
        },
      });
      this.resetSelected();
    },
    resetSelected() {
      this.selectedProcess = new Process();
      this.selectedProcessStage = null;
      this.selectedProcessStageSteps = [];
      this.selectedProcessStageStep = {};
    },
  },
  components: {
    newProcessPopup: () => import('./newProcessPopup'),
    editProcessPopup: () => import('./editProcessPopup'),
    editProcessStagePopup: () => import('./editProcessStagePopup'),
    editProcessStageStepPopup: () => import('./editProcessStageStepPopup'),
    process: () => import('./process.vue'),
  },
};
</script>
